<div style="height:100%;padding: 10px 0px 10px 0px;">
	<div class="exception-list">
		<div *ngFor="let item of recordExceptions | keyvalue;" class="exception-item">
			<div *ngFor="let cdItem of item.value | keyvalue">
				<div class="operations">
					<i class="glyphicons glyphicons-bin" (click)="remove(cdItem.value)"></i>
				</div>
				<div class="attribute-list">
					<ng-container *ngFor="let attr of attributes; let idx2 = index;">
						<div *ngIf="!(attr.prop==='value'&&item.key===qaNotesGeomColName)" class="attribute-row">
							<div class="column-cell">
								{{attr.name}}
							</div>
							<div class="value-cell" title="{{cdItem.value[attr.prop]}}">
								<input name="val-{{item.key}}-{{cdItem.key}}-{{idx2}}" disabled [(ngModel)]="cdItem.value[attr.prop]">
								<!-- {{exc[attr.prop]}} -->
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
		<!-- <div *ngFor="let exc of exceptions; let idx = index;" class="exception-item">
			<div class="operations">
				<i class="glyphicons glyphicons-bin" (click)="remove(exc)"></i>
			</div>
			<div class="attribute-list">
				<div *ngFor="let attr of attributes; let idx2 = index;" class="attribute-row">
					<div class="column-cell">
						{{attr.name}}
					</div>
					<div class="value-cell" title="{{exc[attr.prop]}}">
						<input name="val-{{idx}} - {{idx2}}" disabled [(ngModel)]="exc[attr.prop]">
					</div>
				</div>
			</div>
		</div> -->
	</div>
</div>